// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","alternative":"Button_alternative__aygL4","secondary":"Button_secondary__sUGsj"};